const payDatas={
    state: {
        payFormVal: {},
        // socket:'',
    },
    mutations: {
        add_menu:function(state,param){
            state.payFormVal=param
        }
    },
    actions: {
        add_menu({commit}, param) {
          commit('add_menu', param)
        },
      }
}
export default payDatas


// WEBPACK FOOTER //
// ./src/store/components/payData.js